<template>

  <div>
    <!-- Table Container Card -->
    <b-card
      no-body
      class="mb-0"
      style="background: #fff"
    >

      <div class="m-2">

        <!-- Table Top -->
        <b-row>
          <b-col
            cols="12"
            md="6"
            class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
          >
            <span class="text-muted">Showing {{ dataMeta.from }} - {{ dataMeta.to }} of {{ dataMeta.of }}</span>
          </b-col>

          <!-- Search -->
          <b-col
            cols="12"
            md="6"
          >
            <div class="d-flex align-items-center justify-content-end">
              <a
                href="javascript:void(0)"
                class="nav-link nav-link-search"
                @click="showSearchBar = !showSearchBar"
              >
                <feather-icon
                  icon="SearchIcon"
                  size="21"
                  class="mr-50"
                />
                <span class="align-middle">Search</span>
              </a>
              <b-input-group
                v-if="showSearchBar"
                class="input-group-merge mr-50"
              >
                <b-form-input
                  v-model="searchQuery"
                  placeholder="Search..."
                />
                <b-input-group-append is-text>
                  <feather-icon
                    icon="XIcon"
                    class="cursor-pointer"
                    @click="searchQuery = ''; showSearchBar = !showSearchBar"
                  />
                </b-input-group-append>
              </b-input-group>

              <b-dropdown
                id="dropdown-form-purchase-request"
                ref="filter_dropdown_all_delivery_receipt"
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                class="dropdown-modal"
                right
                variant="link"
              >
                <template #button-content>
                  <feather-icon
                    icon="FilterIcon"
                    size="21"
                    class="align-middle mr-50"
                  />
                  <span class="mr-1">Filters</span>
                </template>
                <delivery-receipts-filters
                  :status-filter.sync="statusFilter"
                  :created-at.sync="createdAtFilter"
                  :received-at.sync="receivedAtFilter"
                  :status-options="statusOptions"
                  @emitHideFilter="hideFilter"
                  @emitShowFilter="showFilter"
                />
              </b-dropdown>
            </div>
          </b-col>
        </b-row>
        <div v-if="createdAtFilter || receivedAtFilter || statusFilter.length">
          <hr class="dividerHR filter-divider">
          <b-row>

            <!-- Per Page -->
            <b-col
              cols="12"
              md="12"
              class="d-flex align-items-center justify-content-start mb-1 mb-md-0"
            >
              <ul
                class="list-inline d-inline-block mb-1"
              >
                <li
                  v-for="statusVal in statusFilter"
                  :key="statusVal"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="removeFromStatusFilter(statusVal)"
                  >
                    <span class="text-capitalize">{{ statusVal.replace("-", " ") }}</span>
                  </b-form-tag>
                </li>
                <li
                  v-if="createdAtFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="createdAtFilter = ''"
                  >
                    {{ createdAtFilter }}
                  </b-form-tag>
                </li>
                <li
                  v-if="receivedAtFilter"
                  class="list-inline-item"
                >
                  <b-form-tag
                    class="mb-50"
                    variant="danger"
                    @remove="receivedAtFilter = ''"
                  >
                    {{ receivedAtFilter }}
                  </b-form-tag>
                </li>
                <li
                  class="list-inline-item"
                >
                  <span
                    class="text-danger clear-filter-text mb-50"
                    @click="clearAllFilters"
                  >
                    Clear Filters
                  </span>
                </li>
              </ul>
            </b-col>
          </b-row>
        </div>
      </div>

      <b-table
        ref="refAllDeliveryReceiptsTable"
        class="position-relative event_list has_padding delivery_table"
        :items="fetchDeliveryReceipts"
        responsive
        :fields="tableColumns"
        primary-key="_id"
        :sort-by.sync="sortBy"
        show-empty
        no-sort-reset
        empty-text="No matching records found"
        :sort-desc.sync="isSortDirDesc"
      >
        <!-- Column: Role -->
        <template #cell(stringID)="data">
          <div class="text-nowrap">
            <b-button
              v-ripple.400="'rgba(30, 30, 30, 0.15)'"
              variant="none"
              class="text-bold-black align-middle detail-view-id not-button"
            >
              {{ data.item.stringID }}
            </b-button>
          </div>
        </template>

        <template #cell(createdAt)="data">
          <div class="text-nowrap">
            <span class="">{{ dateFormatWithTime(data.item.createdAt) }}</span>
          </div>
        </template>

        <template #cell(receivedDate)="data">
          <div class="text-nowrap">
            <span class="">{{ dateFormatWithTime(data.item.receivedDate) }}</span>
          </div>
        </template>

        <template #cell(remarks)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.remarks ? data.item.remarks : '-' }}</span>
          </div>
        </template>

        <template #cell(purchaseRequest)="data">
          <div class="text-nowrap">
            <div v-if="data.item.purchaseRequest">
              <div v-if="canViewThisAction('show', 'Vendor') && !$route.params.id">
                <b-button
                  variant="link"
                  class="p-0"
                  :to="{ name: 'purchasing-vendors-show', params: { id: data.item.vendor ? data.item.vendor._id : 0 } }"
                >
                  {{ data.item.vendor ? data.item.vendor.companyName : '' }}
                </b-button>
              </div>
              <div v-else>
                <span>{{ data.item.vendor ? data.item.vendor.companyName : '' }}</span>
              </div>
              <div v-if="canViewThisAction('show', 'PurchaseRequest') && !$route.params.id">
                <b-button
                  variant="link"
                  class="p-0"
                  :to="{ name: 'purchasing-purchase-request-show', params: { id: data.item.purchaseRequest ? data.item.purchaseRequest._id : 0 }, query: { from: $route.name == 'purchasing-my-delivery-receipts-index' ? 'my-pr' : '' } }"
                >
                  {{ data.item.purchaseRequest ? data.item.purchaseRequest.caseID : '' }}
                </b-button>
              </div>
              <div v-else>
                <span>{{ data.item.purchaseRequest ? data.item.purchaseRequest.caseID : '' }}</span>
              </div>
            </div>
            <div v-else>
              <span>-</span>
            </div>
          </div>
        </template>

        <template #cell(attachments)="data">
          <div class="text-nowrap">
            <div
              v-for="(file, key) in data.item.attachments"
              :key="key"
            >
              <strong>
                <b-link
                  v-if="file.fileStorage"
                  :to="{ name: 'file-view', params: { id: file.fileStorage } }"
                  target="_blank"
                >
                  {{ file ? file.name : '' }}
                </b-link>
                <b-link
                  v-else-if="file.data && file.data.startsWith('http')"
                  :href="file ? file.data : ''"
                  target="_blank"
                >
                  {{ file ? file.name : '' }}
                </b-link>
              </strong>
            </div>
          </div>
        </template>

        <template #cell(createdBy)="data">
          <div class="text-nowrap">
            <span class="">{{ data.item.createdBy ? data.item.createdBy.name : '' }}</span>
          </div>
        </template>

        <!-- Column: Status -->
        <template #cell(status)="data">
          <b-badge
            :variant="`light-${resolveDeliveryReceiptStatusVariant(data.item.status)}`"
            class="text-capitalize"
          >
            {{ data.item.status == 'linked' ? 'Linked to PO' : 'Pending Link' }}
          </b-badge>
        </template>

        <!-- Column: Actions -->
        <template
          v-if="canViewThisAction('link-to-po', 'DeliveryReceipt') || canViewThisAction('update', 'DeliveryReceipt')"
          #cell(actions)="data"
        >
          <b-dropdown
            variant="link"
            no-caret
            :right="$store.state.appConfig.isRTL"
          >

            <template #button-content>
              <feather-icon
                icon="MoreVerticalIcon"
                size="16"
                class="align-middle text-body"
              />
            </template>

            <b-dropdown-item
              v-if="canViewThisAction('update', 'DeliveryReceipt')"
              :to="{ name: 'purchasing-delivery-receipts-edit', params: { id: data.item._id }, query: { from: $route.name == 'purchasing-my-delivery-receipts-index' ? 'my-dr' : '' } }"
            >
              <feather-icon icon="EditIcon" />
              <span class="align-middle ml-50">Edit</span>
            </b-dropdown-item>

            <b-dropdown-item
              v-if="canViewThisAction('link-to-po', 'DeliveryReceipt')"
              :to="{ name: 'purchasing-delivery-receipts-link-to-po', params: { id: data.item._id }, query: { from: $route.name == 'purchasing-my-delivery-receipts-index' ? 'my-dr' : '' } }"
            >
              <feather-icon icon="LinkIcon" />
              <span class="align-middle ml-50">Link to PO/PRF</span>
            </b-dropdown-item>
          </b-dropdown>
        </template>

      </b-table>
    </b-card>

    <div
      v-if="totalDeliveryReceipts > perPage"
      class="mx-2 mb-2"
    >
      <b-row>
        <!-- Pagination -->
        <b-col
          cols="12"
          sm="12"
          class="d-flex align-items-center justify-content-center pagination-content"
        >

          <b-pagination
            v-model="currentPage"
            :total-rows="totalDeliveryReceipts"
            :per-page="perPage"
            first-number
            last-number
            class="mb-0 mt-1 mt-sm-0"
            align="center"
            prev-text="Prev"
            next-text="Next"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
              <span>Prev</span>
            </template>
            <template #next-text>
              <span>Next</span>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>

        </b-col>

      </b-row>
    </div>
  </div>
</template>

<script>
import {
  BCard, BRow, BCol, BFormInput, BTable, BInputGroup, BInputGroupAppend, BLink,
  BBadge, BDropdown, BDropdownItem, BPagination, BButton, BFormTag,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { ref, onUnmounted } from '@vue/composition-api'
import { avatarText } from '@core/utils/filter'
import { required } from '@validations'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { useUtils as useAclUtils } from '@/libs/acl/custom'

import store from '@/store'

import useAllDeliveryReceiptsList from './useAllDeliveryReceiptsList'
import deliveryReceiptsStoreModule from '../deliveryReceiptsStoreModule'
import DeliveryReceiptsFilters from '../DeliveryReceiptsFilters.vue'

export default {
  components: {
    // UserListAddNew,
    BButton,
    BCard,
    BRow,
    BCol,
    BFormInput,
    BTable,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BInputGroup,
    BInputGroupAppend,
    BFormTag,
    BLink,

    // eslint-disable-next-line vue/no-unused-components
    ToastificationContent,

    DeliveryReceiptsFilters,
  },
  directives: {
    Ripple,
  },
  // props: {
  //   vendorOptions: {
  //     type: Array,
  //     required: true,
  //   },
  // },
  data() {
    return {
      bulkStatus: '',
      bulkStatusValidation: false,
      bulkStatusError: 'Valid status is required',
      statusDataOptions: [
        { title: 'Linked', code: 'linked' },
        { title: 'Pending', code: 'pending' },
      ],
      showFilterDropdown: process.env.VUE_APP_SHOW_FILTER_DROPDOWN,

      required,
    }
  },

  methods: {
    hideFilter() {
      this.$refs.filter_dropdown_all_delivery_receipt.hide(true)
    },
    showFilter() {
      this.$refs.filter_dropdown_all_delivery_receipt.show(true)
    },
    removeFromStatusFilter(item) {
      const index = this.statusFilter.indexOf(item)
      if (index > -1) {
        this.statusFilter.splice(index, 1)
      }
    },

    clearAllFilters() {
      this.createdAtFilter = ''
      this.receivedAtFilter = ''
      this.statusFilter = []
    },
    deleteEntity(id) {
      this.$swal({
        title: 'Are You Sure?',
        html: 'Selecting Delete will <strong>permanently delete</strong> this item. This action cannot be undone.',
        // eslint-disable-next-line global-require
        imageUrl: require('@/assets/images/icons/warning.png'),
        reverseButtons: true,
        showCancelButton: true,
        cancelButtonText: 'No, Cancel',
        confirmButtonText: 'Yes, Delete!',
        customClass: {
          confirmButton: 'btn btn-danger ml-1',
          cancelButton: 'btn btn-outline-primary',
        },
        buttonsStyling: false,
      })
        .then(result => {
          if (result.value) {
            this.toDeletedID = id
            this.deleteDeliveryReceipt()
          }
        })
    },
  },
  setup() {
    const showSearchBar = ref(false)
    const showFilterOptions = ref(false)
    const DELIVERY_RECEIPT_APP_STORE_MODULE_NAME = 'app-all-delivery-receipt'

    // Register module
    if (!store.hasModule(DELIVERY_RECEIPT_APP_STORE_MODULE_NAME)) store.registerModule(DELIVERY_RECEIPT_APP_STORE_MODULE_NAME, deliveryReceiptsStoreModule)

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(DELIVERY_RECEIPT_APP_STORE_MODULE_NAME)) store.unregisterModule(DELIVERY_RECEIPT_APP_STORE_MODULE_NAME)
    })

    const statusOptions = [
      { label: 'Linked', value: 'linked' },
      { label: 'Pending', value: 'pending' },
    ]

    const { canViewThisAction } = useAclUtils()

    const {
      fetchDeliveryReceipts,
      tableColumns,
      perPage,
      currentPage,
      totalDeliveryReceipts,
      deliveryReceiptData,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refAllDeliveryReceiptsTable,
      refetchData,

      toDeletedID,
      deleteDeliveryReceipt,

      // UI
      resolveDeliveryReceiptStatusVariant,

      // Extra Filters
      statusFilter,
      createdAtFilter,
      receivedAtFilter,
    } = useAllDeliveryReceiptsList()

    return {

      // Sidebar

      fetchDeliveryReceipts,
      tableColumns,
      perPage,
      currentPage,
      totalDeliveryReceipts,
      dataMeta,
      perPageOptions,
      searchQuery,
      sortBy,
      isSortDirDesc,
      refAllDeliveryReceiptsTable,
      refetchData,
      showSearchBar,
      showFilterOptions,
      toDeletedID,
      deleteDeliveryReceipt,
      deliveryReceiptData,

      // Filter
      avatarText,
      canViewThisAction,

      // UI
      resolveDeliveryReceiptStatusVariant,

      statusOptions,

      // Extra Filters
      statusFilter,
      receivedAtFilter,
      createdAtFilter,
    }
  },
}
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}
</style>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
